module.exports = __webpack_public_path__ + "img/upwork-top-rated.29100e1e.png";